
function Common () {
  this.getLanguageType = function () {
    if (localStorage.getItem('odmLanguageType')) {
      return localStorage.getItem('odmLanguageType')
    } else {
      return '1'
    }
  }
}

export default new Common()



// WEBPACK FOOTER //
// ./src/utils/common.js